/**
 * `cn` — merge conditional class names and resolve Tailwind conflicts.
 *
 * `clsx` handles conditional/array/object inputs; `tailwind-merge` ensures the
 * last conflicting Tailwind utility wins (e.g. `cn('p-2', 'p-4')` → `'p-4'`).
 */
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
